import { render, staticRenderFns } from "./CadastrarPerfil.vue?vue&type=template&id=cfa47d78&scoped=true"
import script from "./CadastrarPerfil.vue?vue&type=script&lang=js"
export * from "./CadastrarPerfil.vue?vue&type=script&lang=js"
import style0 from "./CadastrarPerfil.vue?vue&type=style&index=0&id=cfa47d78&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa47d78",
  null
  
)

export default component.exports